export const getTokenName = (): string => {
  return process.env?.REACT_APP_TOKEN_NAME || 'pwa-token';
};
